import axios from 'axios'

export interface TherapeuticAreaTopic {
  id?: number
  name: string
  description?: string | null
}

export interface TherapeuticAreaTheme {
  id?: number
  name: string
  description?: string | null
  topics?: TherapeuticAreaTopic[]
}

export interface TherapeuticAreaMaterial {
  id?: number
  name: string
  value?: number | null
}

export interface TherapeuticArea {
  id?: number
  name: string
  description?: string | null
  themes?: TherapeuticAreaTheme[]
  materials?: TherapeuticAreaMaterial[]
}

export default class TherapeuticAreaService {
  private baseUrl = '/api/v1/therapeutic-areas'

  public getAll() {
    return axios.get(`${this.baseUrl}`)
  }

  public getById(id: number) {
    return axios.get(`${this.baseUrl}/${id}`)
  }

  public create(payload: Partial<TherapeuticArea>) {
    return axios.post(`${this.baseUrl}`, payload)
  }

  public update(id: number, payload: Partial<TherapeuticArea>) {
    return axios.put(`${this.baseUrl}/${id}`, payload)
  }

  public delete(id: number) {
    return axios.delete(`${this.baseUrl}/${id}`)
  }
}
